import { Button, Card, Flex, Stack, Text } from '@mantine/core'
import { RiHeadphoneLine } from '@remixicon/react'
import { useTranslations } from 'next-intl'

export const ScheduleACall = () => {
  const t = useTranslations('Ui.customer-support')
  return (
    <Card
      radius='lg'
      className='flex flex-col items-start'
      p='md'
      my='lg'
      bg='var(--color-background-schedule-call)'
      withBorder
    >
      <Flex gap='sm' mb='sm' direction='column'>
        <div className='bg-[var(--color-background-gray)] p-4 rounded-full self-start'>
          <RiHeadphoneLine size={20} />
        </div>
        <Stack gap={2}>
          <Text
            c='var(--mantine-color-Neutral-0)'
            className='!font-semibold !text-sm'
          >
            {t('title')}
          </Text>
          <Text c='var(--mantine-color-Neutral-0)' className='!text-xs'>
            {t('description')}
          </Text>
        </Stack>
      </Flex>
      <Button
        bg='var(--mantine-color-Neutral-0)'
        c='var(--mantine-color-Neutral-8)'
        radius='md'
        px='sm'
      >
        {t('button-text')}
      </Button>
    </Card>
  )
}
